import _get from 'lodash/get'

/**
 * Strips the numeric prefix (e.g. "9 - ") and trailing " RC" from
 * rainbow-category names.  "9 - Coverups RC" → "Coverups"
 */
export function cleanRCName (name: string): string {
  return (name || '')
    .replace(/^\d+\s*[-\u2013]\s*/, '')
    .replace(/\s+RC$/i, '')
    .trim()
}

/**
 * Given an array of raw playlist items (each with
 * `content[0].references`), returns the cleaned name of the
 * most-frequently occurring rainbow-category reference, or ''.
 */
interface RainbowCategoryReference {
  contentReferenceType?: { type?: string | null }
  contentTo?: Array<{ title?: string | null }>
}

interface RainbowCategoryItem {
  content?: Array<{ references?: RainbowCategoryReference[] | null } | null>
}

export function getDominantRainbowCategory (
  items: RainbowCategoryItem[] | null | undefined,
): string {
  const counts: Record<string, number> = {}
  const safeItems = items || []
  safeItems.forEach((item) => {
    const refs: RainbowCategoryReference[] = _get(item, 'content[0].references', []) || []
    refs.forEach((ref) => {
      const type: string = _get(ref, 'contentReferenceType.type', '') || ''
      if (type === 'rainbow-category') {
        const title: string = _get(ref, 'contentTo[0].title', '') || ''
        if (title) counts[title] = (counts[title] || 0) + 1
      }
    })
  })
  const sorted = Object.entries(counts)
    .sort((a, b) => b[1] - a[1])
  return sorted.length > 0 ? cleanRCName(sorted[0][0]) : ''
}
